import { Theme } from '@material-ui/core/styles';

// ----------------------------------------------------------------------

type ToggleButtonReturn = { MuiToggleButton: { styleOverrides: { root: { border: string; color: string; '&.Mui-selected': { backgroundColor: string; color: string }; '&.Mui-disabled': { color: string } } } } }
export const ToggleButton = (theme: Theme): ToggleButtonReturn => {
  const isLight = theme.palette.mode === 'light';

  return {
    MuiToggleButton: {
      styleOverrides: {
        root: {
          color: theme.palette.grey[500],
          border: `solid 1px ${theme.palette.grey[500_32]}`,
          '&.Mui-selected': {
            color: theme.palette.grey[isLight ? 600 : 0],
            backgroundColor: theme.palette.action.selected,
          },
          '&.Mui-disabled': {
            color: theme.palette.grey[500_48],
          },
        },
      },
    },
  };
};
